import React, { memo, useEffect } from 'react';
import Button from '../../../global/atoms/button/button';
import { getApplicationStatus } from '../utils/cashflowUtils';
import AlertSuccessCircle from '../../../../resources/images/check_mark_icon.svg';
import { AEM_CONTAINS_EMAIL, CREATE_ACCOUNT_SCREEN, LOGIN_SCREEN } from '../../constants';
import { ApplicationStatusTestId } from '../../GRTestId';
import { STORAGE_CONFIG } from '../../../../constants/storageConfig';
import { clearCache } from '../../utils/guidedUtil';
import './ApplicationStatus.scss';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';
import { isValidString } from '../../../global/utils/logger';

const ApplicationStatus = () => {
    const { applicationstatusconfig = {} } = getApplicationStatus() || {};
    const { sendEventsForGRModalCTAClicked } = useAnalyticsContext();
    const {
        headerTitleLabel = '',
        availRentalEquipmentTextLabel = '',
        accountStatusMessage = '',
        startRentingButtonLabel = ''
    } = applicationstatusconfig || {};
    const emailId = sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.GR_EMAIL);

    useEffect(() => {
        if (isValidString(sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.CCA_SUBMISSION_ID))) {
            clearCache();
        } else {
            window.location.href = CREATE_ACCOUNT_SCREEN;
        }
    }, []);

    const navigatetoLogin = () => {
        sendAnalyticsClickEvent();
        window.location.href = LOGIN_SCREEN;
    };
    const sendAnalyticsClickEvent = () => {
        sendEventsForGRModalCTAClicked(
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
            startRentingButtonLabel,
            EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FIELD_FORM_SUBMITTED_LINK_TYPE,
            EVENT_ECOMMERCE_NAMES_CONFIG.LINK_TYPE_LOCATION_BODY,
            LOGIN_SCREEN
        );
    };

    return (
        <div className="container">
            <div className="row stepform__row personal_application_status__screen-styles">
                <div className="col-lg-5 col-md-8">
                    <div className="personal_application_status">
                        <div className="personal_application_status__icon-style">
                            <div className="personal_application_status__icon">
                                <AlertSuccessCircle />
                            </div>
                        </div>

                        <div className="personal_application_status">
                            <h4
                                className="personal_application_status__header"
                                data-testid={ApplicationStatusTestId.HEADER}>
                                {headerTitleLabel}
                            </h4>
                            <p
                                className="personal_application_status__msg"
                                data-testid={ApplicationStatusTestId.SUB_TITLE}>
                                {availRentalEquipmentTextLabel}
                            </p>
                            <p
                                data-testid={ApplicationStatusTestId.CONTENT}
                                dangerouslySetInnerHTML={{
                                    __html: `${accountStatusMessage?.replace(
                                        AEM_CONTAINS_EMAIL,
                                        `<strong>${emailId}</strong>`
                                    )}`
                                }}></p>
                        </div>

                        <div className="personal_application_status__actions">
                            <Button
                                tabIndex={0}
                                onClick={navigatetoLogin}
                                className="button button-primary personal_application_status__btn"
                                data-testid={ApplicationStatusTestId.BUTTON_LABEL}>
                                {startRentingButtonLabel}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(ApplicationStatus);
